import React from 'react';
import Autocomplete from 'apollo-react/components/Autocomplete';
import Info from 'apollo-react-icons/Info';
const getErrorMessage = (error) => {
  if (!error) return '';
  if (typeof error === 'string') return error;

  // If it's an array of errors (common in Formik/Zod for lists)
  if (Array.isArray(error)) {
    const firstError = error.find((e) => !!e);
    return getErrorMessage(firstError);
  }

  // If it's an object (e.g., { order: 'required' })
  if (typeof error === 'object') {
    const firstKey = Object.keys(error)[0];
    return getErrorMessage(error[firstKey]);
  }

  return 'Invalid value';
};
const AutocompleteInput = ({
  field,
  meta,
  label,
  options,
  onChange,
  value,
  required,
  placeholder,
  disabled,
  multiple,
}) => {
  return (
    <Autocomplete
      {...field}
      label={
        <span>
          {label} {<Info fontSize="extraSmall" style={{ color: '#595959' }} />}
        </span>
      }
      placeholder={placeholder}
      helperText={
        meta?.touched && meta?.error ? getErrorMessage(meta.error) : ''
      }
      source={options}
      fullWidth
      required={required}
      value={value}
      multiple={multiple}
      disabled={disabled}
      onChange={(event, newValue) => onChange(newValue)}
    />
  );
};

export default AutocompleteInput;
